<template>
  <vs-row>
    <vs-col :vs-w="showFiltersTransition ? 9 : 12" class="p-2">
      <vx-card v-if="referrals"
               v-show="filterValues">
        <div class="flex flex-end">
          <feather-icon class="filter-hover-button" @click="onShowFilters()" icon="FilterIcon"
                        :svgClasses="'h-8 w-8 mb-1 mr-3 stroke-current text-primary'"/>
        </div>
        <sm-hateoas-table
          ref="referralTable"
          @selected="handleSelected"
          :paged-resources="referrals"
          :relation="'referrals'"
          :search="true"
          :pagination="true"
          :filters="filterValues">
          <template slot="thead">
          <vs-th sort-key="acceptance.firstSent">
            {{ $t('view_referrals.first_sent') }}
          </vs-th>
          <vs-th sort-key="claimant.firstname">
            {{ $t('view_referrals.name') }}
          </vs-th>
          <vs-th sort-key="action.accessCode.program">
            {{ $t('view_referrals.program') }}
          </vs-th>
          <vs-th v-if="isCaseManagerTeamOn" sort-key="action.caseManagerTeam.name">
            {{ hqTeamLabel }}
          </vs-th>
          <vs-th>
            {{ $t('view_referrals.referral_status') }}
          </vs-th>
          <vs-th>
          </vs-th>
          </template>

          <template slot-scope="{data}">
          <vs-tr :data="tr" :key="data[indextr].id" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].$getEmbedded('referral-acceptance').firstSent">
              {{ data[indextr].$getEmbedded('referral-acceptance').firstSent | moment('MMM D, YYYY') }}
            </vs-td>

            <vs-td :data="data[indextr].name">
              <div>
            <span>{{
                data[indextr].$getEmbedded('referral-claimant').firstname + ' ' + data[indextr].$getEmbedded('referral-claimant').lastname
              }}</span>
              </div>
              <div>
                <span>{{ data[indextr].$getEmbedded('referral-claimant').email }}</span>
              </div>
              <div>
                <span>{{ userIdLabel }}: {{ data[indextr].$getEmbedded('referral-claim').claimNumber }}</span>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].program">
              {{ $t('filters.REFERRAL_PROGRAMS.values.' + data[indextr].$getEmbedded('referral-action').$getEmbedded('access-code').program) }}
            </vs-td>

            <vs-td v-if="isCaseManagerTeamOn" :data="data[indextr].hqTeamName">
              {{ data[indextr].hqTeamName ? data[indextr].hqTeamName : '--' }}
            </vs-td>

            <vs-td :data="data[indextr].status">
              <span :class="data[indextr].status === 'ERRORED' ? 'text-danger':''">{{
                  $t('filters.REFERRAL_STATUS.values.' + data[indextr].status)
                }}</span>
            </vs-td>

            <vs-td>
              <template v-if="data[indextr].status === 'CANCELLED'">
              <vs-col vs-w="12" class="p-2">
                <vs-button
                  v-if="data[indextr].$hasLink('referral')"
                  type="border"
                  color="primary"
                  class="w-full"
                  @click="onView(data[indextr])">
                  {{ $t('view_referrals.buttons.view') }}
                </vs-button>
              </vs-col>
              </template>
              <template v-else-if="data[indextr].status === 'ACCEPTED'">
                <vs-row>
                  <vs-col vs-w="12" class="p-2">
                    <vs-button
                      v-if="data[indextr].$getEmbedded('user')"
                      type="filled"
                      color="secondary"
                      class="w-full"
                      @click="onMemberView(data[indextr].$getEmbedded('user'))">
                      {{ $t('view_referrals.buttons.view_member') }}
                    </vs-button>
                    <vs-button
                      v-else-if="data[indextr].$hasLink('referral')"
                      type="filled"
                      color="primary"
                      class="w-full"
                      @click="onView(data[indextr])">
                      {{ $t('view_referrals.buttons.view') }}
                    </vs-button>
                  </vs-col>
                </vs-row>
              </template>
              <template v-else>
                <vs-row>
                  <vs-col vs-w="6" class="p-2">
                    <sm-interval-button
                      v-if="data[indextr].$hasLink('notify-claimant') && data[indextr].status !== 'DISCHARGED'"
                      type="filled" color="primary" class="w-full px-0"
                      :key="data[indextr].$getEmbedded('referral-acceptance').lastSent + indextr"
                      :label="$t('view_referrals.buttons.resend')"
                      :baseTime="data[indextr].$getEmbedded('referral-acceptance').lastSent"
                      @click="onResend(data[indextr])">
                    </sm-interval-button>

                    <vs-button
                      v-if="data[indextr].status === 'ERRORED' && data[indextr].$hasLink('edit') && data[indextr].status !== 'DISCHARGED'"
                      type="border"
                      color="primary"
                      class="w-full"
                      @click="onView(data[indextr])">
                      {{ $t('view_referrals.buttons.edit') }}
                    </vs-button>
                  </vs-col>
                  <vs-col vs-w="6" class="p-2">
                    <vs-button
                      v-if="data[indextr].$hasLink('referral') && data[indextr].status !== 'DISCHARGED'"
                      type="filled"
                      color="secondary"
                      class="w-full"
                      @click="onView(data[indextr])">
                      {{ $t('view_referrals.buttons.view') }}
                    </vs-button>
                  </vs-col>
                </vs-row>
              </template>
            </vs-td>

          </vs-tr>
          </template>
        </sm-hateoas-table>
      </vx-card>
    </vs-col>
    <vs-col vs-w="3" class="p-2">
      <sm-hateoas-filters ref="onFilter" v-if="filters" :filter-resource="filterResource" v-show="showFiltersTransition" @update-transition="onUpdateFilterTransition"
                          :filters="filters" @filters-change="onFilterChange"></sm-hateoas-filters>
    </vs-col>
  </vs-row>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';
import SmHateoasFilters from '@/components/starling/sm-hateoas-filters/sm-hateoas-filters';
import SmIntervalButton from '@/components/starling/sm-interval-button/sm-interval-button';

export default {
  name: 'view-referrals',
  components: {
    SmHateoasTable,
    SmHateoasFilters,
    SmIntervalButton
  },
  props: {
    referralsResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      referrals: this.referralsResource,
      filters: null,
      filterValues: null,
      showFilters: false,
      showFiltersDelayed: false,
      showFiltersTransition: false,
      userIdLabel: null,
      filterResource: null,
      isCaseManagerTeamOn: null,
      hqTeamLabel: null
    };
  },
  mounted () {
    this.isCaseManagerTeamOn = this.$store.state.router.profileResource.caseManagerTeamOn;
    this.referrals.$request().$get('user-id-label', null, {locale: 'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('view_member.block.report.fields.user_id');
      }
    });
    this.referrals.$request().$get('hq-team-label', null, {locale: 'en'}).then((res) => {
      this.isCaseManagerTeamOn = res.state().enabled;
      this.hqTeamLabel = res.state().label;
      if (!this.hqTeamLabel) {
        this.hqTeamLabel = this.$t('view_referrals.team');
      }
    });
    if (this.referrals.$hasLink('filters')) {
      this.referrals.$request().$get('filters').then(res => {
        this.filters = res.$getEmbedded('filters');
        this.filterResource = res;
      });
    }
  },
  methods: {
    handleSelected () {

    },
    onFilterChange (filters) {
      this.filterValues = filters;
    },
    refreshTable () {
      this.$refs.referralTable.refresh();
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    },
    onResend (referral) {
      const claimant = referral.$getEmbedded('referral-claimant');
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Resend referral',
        text: `Are you sure you want to re-send the notification to claimant ${claimant.firstname} ${claimant.lastname}?`,
        accept: () => {
          referral.$request().$post('notify-claimant').then(() => {
            this.$emit('updated');
            this.$vs.notify({
              title: 'Notification sent',
              text: `The claimant ${claimant.firstname} ${claimant.lastname} has been correctly notified.`,
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
            this.refreshTable();
          }, () => {
            this.$vs.notify({
              title: 'Notification not sent',
              text: `An error occured. The claimant ${claimant.firstname} ${claimant.lastname} has not been notified.`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        }
      });
    },
    onView (referral) {
      this.$router.push({
        name: 'app-view-referral',
        params: {id: referral.id}
      });
    },
    onMemberView (member) {
      this.$router.push({
        name: 'app-view-member',
        params: {id: member.id}
      });
    },
    onEdit (referral) {
      this.$router.push({
        name: 'app-edit-referral',
        params: {
          id: referral.id
        }
      });
    }
  }
};
</script>
